import { useState, useEffect } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { Box, Container, Typography, Grid } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';

// layout
import HomeLayout from '/layouts/HomeLayout';

// components
import WysiwygViewer from '/components/shared/TextEditorViewer';
import ListItem from '/components/modules/NewsList/ListItem';
import BackButton from '/components/shared/BackButton';

// actions
import { getNews, getOneNews } from '/context/actions/news';

// icons
import { Clock as ClockIcon } from 'react-feather';

// utils
import useWindowSize from 'utils/useWindowSizes';

const useStyles = makeStyles(() => ({
    root: {
        marginTop: 144,
        marginBottom: 40,
    },
    list: {
        paddingBottom: 30,
    },
    bttn: {
        backgroundColor: 'whitesmoke',
        padding: '6px 10px',
        margin: 0,
        '& .MuiButton-startIcon': {
            margin: '0px !important',
        },
    },
    bttnIcon: {
        fontSize: '16px !important',
    },
}));

const NewsMore = () => {
    const classes = useStyles();
    const router = useRouter();
    const { sizes } = useWindowSize();
    const [news, setNews] = useState(null);
    const [post, setPost] = useState(null);

    useEffect(() => {
        getNews('?page=1&limit=5').then((result_news) => {
            setNews(result_news.list);
        });
    }, []);

    useEffect(() => {
        if (router.query.id !== undefined) {
            getOneNews(router.query.id).then((result_post) => {
                setPost(result_post);
            });
        }
    }, [router]);

    const handleClickNewsItem = (id) => {
        router.push('/news/' + id);
    };

    if (!post) return <>Ачааллаж байна</>;

    return (
        <Container maxWidth="lg" className={classes.root}>
            <BackButton />
            {sizes.sm ? (
                <>
                    <Grid container spacing={3}>
                        {post && (
                            <Grid item lg={8} md={12} sm={12}>
                                <Typography variant="h1" style={{ marginBottom: 20 }}>
                                    {post.title}
                                </Typography>
                                <Box
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: 15,
                                    }}
                                >
                                    <Box style={{ display: 'flex', flexDirection: 'row' }}>
                                        <ClockIcon style={{ marginRight: 8 }} size={18} />
                                        <Typography variant="body1">
                                            {post.itemType === 'local'
                                                ? post.createdAt.split('T')[0]
                                                : post.createdAt.split('T')[0]}
                                        </Typography>
                                    </Box>
                                </Box>
                                {post.itemType !== 'local' && post.image && (
                                    <Image
                                        src={post.image}
                                        width={16}
                                        height={9}
                                        quality={60}
                                        loader={() => post.image}
                                        alt="news"
                                        layout="responsive"
                                    />
                                )}
                                {post.itemType === 'local' && post.coverImg && (
                                    <Image
                                        src={post.coverImg.url}
                                        width={16}
                                        height={9}
                                        quality={60}
                                        loader={() => post.coverImg.url}
                                        alt="news"
                                        layout="responsive"
                                    />
                                )}
                                <Box style={{ marginTop: 20, marginBottom: 20 }}>
                                    <WysiwygViewer
                                        data={post.itemType !== 'local' ? post.body : post.content}
                                    />
                                </Box>
                            </Grid>
                        )}
                        <Grid item lg={4} md={12} sm={12}>
                            <Box className={classes.list}>
                                {news &&
                                    news.map((item) => {
                                        return (
                                            <ListItem
                                                key={item.id}
                                                size="md"
                                                data={item}
                                                onClick={() => handleClickNewsItem(item.id)}
                                            />
                                        );
                                    })}
                            </Box>
                        </Grid>
                    </Grid>
                </>
            ) : (
                <Grid container spacing={3}>
                    <Grid item lg={4} md={12} sm={12}>
                        <Box className={classes.list}>
                            {news &&
                                news.map((item) => {
                                    return (
                                        <ListItem
                                            key={item.id}
                                            size="md"
                                            data={item}
                                            onClick={() => handleClickNewsItem(item.id)}
                                        />
                                    );
                                })}
                        </Box>
                    </Grid>
                    {post && (
                        <Grid item lg={8} md={12} sm={12}>
                            <Typography variant="h1" style={{ marginBottom: 20 }}>
                                {post.title}
                            </Typography>
                            <Box
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: 15,
                                }}
                            >
                                <Box style={{ display: 'flex', flexDirection: 'row' }}>
                                    <ClockIcon style={{ marginRight: 8 }} size={18} />
                                    <Typography variant="body1">
                                        {post.itemType === 'local'
                                            ? post.createdAt.split('T')[0]
                                            : post.createdAt.split('T')[0]}
                                    </Typography>
                                </Box>
                            </Box>
                            {post.itemType !== 'local' && post.image && (
                                <Image
                                    src={post.image}
                                    width={16}
                                    height={9}
                                    quality={60}
                                    loader={() => post.image}
                                    alt="news"
                                    layout="responsive"
                                />
                            )}
                            {post.itemType === 'local' && post.coverImg && (
                                <Image
                                    src={post.coverImg.url}
                                    width={16}
                                    height={9}
                                    quality={60}
                                    loader={() => post.coverImg.url}
                                    alt="news"
                                    layout="responsive"
                                />
                            )}
                            <Box style={{ marginTop: 20, marginBottom: 20 }}>
                                <WysiwygViewer
                                    data={post.itemType !== 'local' ? post.body : post.content}
                                />
                            </Box>
                        </Grid>
                    )}
                </Grid>
            )}
        </Container>
    );
};

NewsMore.Layout = HomeLayout;

export default NewsMore;
